import { Routes } from '@angular/router';
import { AppComponent } from '@pwaPortal/app.component';

export const routes: Routes = [
  {
    path: 'pwa/:id/pwa.html',
    component: AppComponent,
    data: { isPwaMode: true },
  },
  {
    path: 'pwa/:id',
    component: AppComponent,
    data: { isPwaMode: false },
  },
  {
    path: 'page/:id',
    component: AppComponent,
    data: { isPwaMode: false },
  },
  {
    path: '',
    component: AppComponent,
    data: { isPwaMode: false },
  },
];
